import { Button, Checkbox, Modal } from "@aidkitorg/component-library"
import { ChangeEventHandler, useState } from "react";
import { usePost } from "./API";

export const ResetProgramModal = (props: { open: boolean, onClose: () => void }) => {

  const resetProgram = usePost('/admin/reset');

  const [modules, setModules] = useState({
    dynamo: false,
    faces: false,
    ingestedApplicants: false
  });

  const allSelected = modules.dynamo && modules.faces && modules.ingestedApplicants;

  const handleModuleChange = (moduleName: keyof typeof modules, checked: boolean) => {
    setModules(prev => ({
      ...prev,
      [moduleName]: checked
    }));
  };

  const handleAllChange = (checked: boolean) => {
    setModules({
      dynamo: checked,
      faces: checked,
      ingestedApplicants: checked
    });
  };

  async function reset() {
    const phrase = prompt('What is the passphrase?')
    if (phrase) alert(JSON.stringify(await resetProgram({ passphrase: phrase, modules })));
  }


  return <Modal title="Reset Program" open={props.open} onClose={props.onClose}>
    {/** Modules */}
    <Checkbox 
      label="Reset Everything"
      checked={allSelected}
      onChange={c => handleAllChange(!!c)}
    />
    <Checkbox
      label="Dynamo"
      checked={modules.dynamo}
      onChange={(c) => handleModuleChange('dynamo', !!c)}
    />
    <Checkbox
      label="Faces"
      checked={modules.faces}
      onChange={(c) => handleModuleChange('faces', !!c)}
    />
    <Checkbox
      label="Ingested Applicants"
      checked={modules.ingestedApplicants}
      onChange={(c) => handleModuleChange('ingestedApplicants', !!c)}
    />

    <p>Are you sure you want to reset the program?</p>
    <p>This will delete the selected data for the program and reset it to the initial state.</p>
    <p>This action is irreversible.</p>
    <Button variant="danger" onClick={reset}>Reset Program</Button>
  </Modal>
}